'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1() {
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1.prototype = $p;
$p.ie = (function(scalaValue) {
  return scalaValue;
});
$p.kR = (function(domValue) {
  return domValue;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1, "io.github.nguyenyou.ui5.webcomponents.laminar.shared.StringUnionCodec$$anon$1", ({
  jN: 1,
  bb: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1 };
